<template>
  <div>
    <div class="box">
      <admin-box-item title="적립금 정보" subtitle="회원 등록이 완료된 후 수정을 통해서 이용할 수 있습니다.">
        <table class="info-table" v-if="info">
          <tr>
            <th>총 적립금</th>
            <td>{{ info.save_point|currency }}</td>
          </tr>
          <tr>
            <th>사용된 적립금</th>
            <td>{{ info.use_point|currency }}</td>
          </tr>
          <tr>
            <th>사용가능 적립금</th>
            <td>{{ info.after_point|currency }}</td>
          </tr>
        </table>
      </admin-box-item>

      <admin-box-item title="적립 내역 추가">
        <table class="add-table" v-if="info">
          <tr>
            <th>지급/차감 선택</th>
            <th>금액*</th>
            <th>내용</th>
          </tr>
          <tr>
            <td>
              <select v-model="addForm.type">
                <option v-for="(item,idx) in addOptions" :key="'opt-'+idx" :value="item.value">{{ item.label }}
                </option>
              </select>
            </td>
            <td>
              <input type="number" v-model="addForm.point" :min="0" @input="setNumber">
            </td>
            <td>
              <input type="text" :value="addForm.content" @keyup="e => addForm.content = e.target.value"
                     placeholder="지급 사유">
            </td>
          </tr>
        </table>
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">적립금 {{ addForm.type === 'save' ? '지급': '차감' }}</button>
        </div>
      </admin-box-item>
    </div>
    <div class="box">
      <admin-box-item title="적립금 지급/사용 내역">
        <point-table :list="list"></point-table>
        <pagination ref="pagination" :total_page="total_page" @change="getData"></pagination>
      </admin-box-item>
    </div>
  </div>
</template>

<script>
  import PointTable from "../../../module/common/PointTable";
  import Pagination from "../../../module/common/Pagination";

  export default {
    name: "UserPointManage",
    components: {
      Pagination,
      PointTable
    },
    created() {
      this.getInfo();
      this.getData(1);
    },
    data() {
      return {
        list: [],
        info: undefined,
        total_page: 1,
        addOptions: [
          {
            label: '+ 적립금 지급',
            value: 'save'
          },
          {
            label: '- 적립금 차감',
            value: 'use'
          }
        ],
        addForm: {
          type: 'save',
          point: 0,
          content: ''
        }
      }
    },
    methods: {
      setNumber(e) {
        let point = parseInt(e.target.value.substr(0, 5));
        if (point < 0) {
          point = 0;
        }
        this.addForm.point = point;
      },
      getData(num) {

        this.$axios.get(`admin/member/user/${this.$route.query.id}/point?ordering=-id&page_num=${num}&page_length=10`).then(res => {
          this.list = res.data.data;
          this.total_page = res.data.total_page;
        });
      },
      getInfo() {
        this.$axios.get(`admin/member/user/${this.$route.query.id}/point/info`).then(res => {
          this.info = res.data;
        });
      },
      saveData() {
        if (this.addForm.point === 0) {
          this.toast('적립금 금액을 입력해 주세요');
          return;
        }
        this.$axios.post(`admin/member/user/${this.$route.query.id}/point/add`, this.addForm).then(res => {
          if (res.status === 200) {
            if (this.addForm.type === 'save')
              this.toast('적립금이 지급되었습니다.');
            else
              this.toast('적립금이 차감되었습니다.');
            this.addForm = {
              type: 'save',
              point: 0,
              content: ''
            };
            this.$refs.pagination.page_num = 1;
            this.getData(1);
            this.getInfo();
          }
        });
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .info-table
    width 100%

    table, th, td
      border 1px solid #dddddd

    th, td
      padding 8px 16px

    th
      background-color #eeeeee
      width 140px

  .add-table
    width 100%

    table, th, td
      border 1px solid #dddddd

    th, td
      padding 8px 16px

    th
      text-align center !important
      background-color #eeeeee
      width 140px

  input, select
    border 1px solid #dddddd
    border-radius 3px
    padding 6px 12px
    width 100%

  option
    padding 6px 12px

  select:focus
  input:focus
    outline none
    border 1px solid #ff5722
</style>
